import(/* webpackMode: "eager", webpackExports: ["AuctionListClient"] */ "/vercel/path0/app/list/page-client.tsx");
